import { FacilityAni } from '@reliance/types/models/FacilityAni';
import { useAsync, type UseAsyncReturn } from 'react-async-hook';
import api from '../common/api';
import { IApiResponse, IPaginatedResponse } from '../common/reliance-api-service';

// Editing may include rows without `id` and/or without `facility`.
export type FacilityAniEditable = Omit<FacilityAni, 'facility'> & {
  id?: number;
  facility?: FacilityAni['facility'];
};

function normalizeListItem(raw: FacilityAniEditable): FacilityAniEditable {
  return {
    id: raw.id,
    ani: raw.ani ?? '',
    name: raw.name ?? '',
    extension: raw.extension ?? '',
    facility: raw.facility,
  };
}

/**
 * Loads facility inbound ANIs (`GET /facility-ani?facilityId=`).
 * Call `execute(facilityId)` to refresh.
 */
export function useFacilityAnisList(
  facilityId: number | undefined
): UseAsyncReturn<FacilityAniEditable[], [number | undefined]> {
  return useAsync(
    async (): Promise<FacilityAniEditable[]> => {
      if (facilityId == null) {
        return [];
      }
      const res = await api.get<IApiResponse<IPaginatedResponse<FacilityAniEditable>>>(
        '/facility-ani',
        { params: { facilityId } }
      );
      const list = res.data.data?.data ?? [];
      return list.map((row) => normalizeListItem(row));
    },
    [facilityId]
  );
}
